var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('AppNavbar'),_c('HeroBanner'),_c('SobreNosotros'),_c('NuestrosServicios'),_c('ContacTanos'),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }